import { defineStore } from 'pinia';

export const useEventBus = defineStore('eventBus', {
	actions: {
		subscribe(event, callable = (() => {})) {
			return window.BX?.Event?.EventEmitter?.subscribe(event, callable);
		},

		subscribeOnce(event, callable = (() => {})) {
			return window.BX?.Event?.EventEmitter?.subscribeOnce(event, callable);
		},

		unsubscribe(event, callable) {
			return window.BX?.Event?.EventEmitter?.unsubscribe(event, callable);
		},

		emit(event, data = {}) {
			return window.BX?.Event?.EventEmitter?.emit(event, data);
		},

		emitAsync(event, data = {}) {
			return window.BX?.Event?.EventEmitter?.emitAsync(event, data);
		},

		setMaxListeners(count) {
			return window.BX?.Event?.EventEmitter?.setMaxListeners(count);
		},

		getMaxListeners() {
			return window.BX?.Event?.EventEmitter?.getMaxListeners();
		},

		getListeners(event) {
			return window.BX?.Event?.EventEmitter?.getListeners(event);
		},
	}
});
